import { gql } from '../../__generated__';

export const ENDORSE_COMMENT_MUTATION = gql(/* GraphQL */ `
  mutation endorseComment($targetCommentId: String!) {
    endorseComment(targetCommentId: $targetCommentId) {
      id
      isEndorsed
      endorsementCount
    }
  }
`);

export const UNENDORSE_COMMENT_MUTATION = gql(/* GraphQL */ `
  mutation unendorseComment($targetCommentId: String!) {
    unendorseComment(targetCommentId: $targetCommentId) {
      id
      isEndorsed
      endorsementCount
    }
  }
`);
